module.exports = __webpack_public_path__ + "img/21.9.TU.c91c9bd3.png";